import React from 'react';
import styled, { keyframes } from 'styled-components';
import frog from './assets/frog.gif';
import {
	Radio,
	Fieldset,
  Window,
  WindowContent,
  WindowHeader,
  Button,
  Toolbar,
  Panel
} from 'react95';
import Player from './player';
import song from "./assets/pillion-demo.mp3";

const Wrapper = styled.div`
  .window-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .close-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -1px;
    margin-top: -1px;
    transform: rotateZ(45deg);
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      background: black;
    }
    &:before {
      height: 100%;
      width: 3px;
      left: 50%;
      transform: translateX(-50%);
    }
    &:after {
      height: 3px;
      width: 100%;
      left: 0px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .window {
    min-width: 250px;
    min-height: 200px;
  }
  .window:nth-child(2) {
    margin: 2rem;
  }
  .footer {
    display: block;
    margin: 0.25rem;
    min-height: 31px;
    line-height: 31px;
    padding-left: 0.25rem;
  }
`;

const songs = [
	{
		"name": "Pillion! (demo)",
		"url": song
	}
]

class Content extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isPlaying: false,
			playingSong: ''
		};
	}

	updatePlayingSong = (isPlaying, playingSong) => {
		this.setState({isPlaying, playingSong});
	}

	render() {
		let callback = this.updatePlayingSong
		return (
			<Wrapper>
				<Window resizable className='window'>
					<WindowHeader className='window-header'>
						<span>fallstreak.exe</span>
						<Button>
							<b>X</b>
						</Button>
					</WindowHeader>
					<Toolbar>
						<Player variant="menu" size='sm' callback={callback} songs={songs} />
						<Button variant='menu' size='sm' disabled>
							Tour
						</Button>
					</Toolbar>
					<WindowContent style={{textAlign: 'left' }}>
						<p>
							We are a band. We are working on new music.
						</p>
						<br />
						<Fieldset label='Members'>
							<Radio
								value='Udjo Mau'
								label='🎤 Udjo Mau'
								name='members'
								disabled
							/>
							<br />
							<Radio
								value='Nora'
								label='🎸 Nora'
								name='members'
								disabled
							/>
              <br />
							<Radio
								value='Joseph'
								label='🥁 Joseph'
								name='members'
								disabled
							/>
							<br />
							<Radio
								value='David'
								label='🎸 David'
								name='members'
								disabled
							/>
							<br />
							<center>
							<Button disabled>Fire</Button>
							</center>
						</Fieldset>
					</WindowContent>
					<Panel variant='well' className='footer'>
						{ this.state.isPlaying ? this.state.playingSong : '' }
					</Panel>
				</Window>
        <img src={frog} />
			</Wrapper>
		)
	}
}

export default Content;
